import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import React from "react";

const SlidersIconSvg: React.FC<Partial<CustomIconComponentProps>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.66699 9.66504V13.665H4.33301V12.332H0.333008V10.998H4.33301V9.66504H5.66699ZM13.667 12.332H7V10.998H13.667V12.332ZM12.333 4.99805V6.33203H13.667V7.66504H12.333V8.99805H11V4.99805H12.333ZM9.66699 7.66504H0.333008V6.33203H9.66699V7.66504ZM3 0.332031V4.33203H1.66699V2.99805H0.333008V1.66504H1.66699V0.332031H3ZM13.667 2.99805H4.33301V1.66504H13.667V2.99805Z"
      fill="black"
      fillOpacity="0.55"
    />
  </svg>
);

export const SlidersIcon: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => <Icon component={SlidersIconSvg} {...props} />;
